import React from "react";
import { useSelector } from "react-redux";
import { getMainClassesIds } from "../../../../shared/utils/userDetailsUtils";
import Widget from "../../../../shared/components/features/widget/Widget";
import iconsList from "../../../../shared/components/ui/icons/iconsList";
import GoogleMeetBtn from "../../../../teacher/pages/googleMeet/googleMeetBtn/GoogleMeetBtn";
import classes from "./GoogleMeetWidgetStudent.module.css";

const GoogleMeetWidgetStudent = () => {

    const { texts } = useSelector(state => state.translate);
    const { userDetails } = useSelector(state => state.auth);

    return (
        <Widget
            width={250}
            height={250}
            title={texts.googleMeet}
            icon={iconsList.googleMeet}
            color="#7ED0FF"
            className={classes.GoogleMeetWidgetStudent}
        >
            <div className={classes.WidgetContent}>
                {getMainClassesIds(userDetails).map(mainClass => (
                    <GoogleMeetBtn key={mainClass.id} studyGroup={mainClass} copyBtn={false} />
                ))}
                <div className={classes.GoogleMeetText}>
                    {texts.googleMeetStudentWidgetDescription}
                </div>
            </div>
        </Widget>
    );
};

export default GoogleMeetWidgetStudent;
